import BaseNPCView from "./BaseNPCView";

export default class ActorView extends BaseNPCView {

    constructor(target) {
        super(target);
    }

    get button() {
        return this._target.button;
    }

    stopAnimations() {
        createjs.Tween.removeTweens(this._target);
        this._target.shadow = null;
    }

    blink(count = 2) {
        this._target.alpha = 1;
        this._target.shadow = new createjs.Shadow("#E04A1B", 0, 0, 15);
        const props = { loop: count * 2 - 1, bounce: true, onComplete: this.stopAnimations.bind(this) }
        createjs.Tween.get(this._target, props).to({ alpha: 0 }, 175);
    }

    wiggle() {
        const rotation = 4;
        this._target.rotation = -rotation;
        const props = { loop: 3, bounce: true, onComplete: () => {
            this._target.rotation = 0; 
        } };
        createjs.Tween.get(this._target, props).to({ rotation: rotation }, 60);
    }

};
